<template>
  <BjGraph
    v-if="refresh"
    ref="BjGraph"
    :api="api"
    edge-text
    :click-edge="hasPermissionBtn"
    :movable="hasPermissionBtn"
    only-ratio-virtual
    @refresh="refreshData"
  />
</template>
<script>
import { stockApi } from '@/api';
import BjGraph from '@/components/BjGraph';
export default {
  name: 'SettingStockRatioConfig',
  components: { BjGraph },
  data() {
    return {
      api: stockApi.getAllwarehouseSetting,
      refresh: true,
    };
  },
  computed: {
    // 是否有配置权限
    hasPermissionBtn() {
      return this.$store.getters.userPermissionBtns.includes(
        'SettingStockRatioConfig_Set'.toLocaleLowerCase(),
      );
    },
  },
  mounted() {},
  // beforeRouteLeave(to, from, next) {
  //   // if (this.$refs.BjGraph.isChange) {
  //   //   this.$confirm('数据尚未保存，确定要离开吗？', this.$t('toast.hintText'), {
  //   //     confirmButtonText: this.$t('toast.okText'),
  //   //     cancelButtonText: this.$t('toast.cancelText'),
  //   //     type: 'warning',
  //   //   })
  //   //     .then(() => {
  //   //       next();
  //   //     })
  //   //     .catch(() => {
  //   //       next(false);
  //   //     });
  //   // }
  //   // 判断用户是否拖拽过元素，提示用户保存
  //   // if (this.$refs.BjGraph.isChange) {
  //   //   this.$confirm('发现您有拖拽未保存的数据，是否保存当前数据？', this.$t('toast.hintText'), {
  //   //     confirmButtonText: this.$t('toast.okText'),
  //   //     cancelButtonText: this.$t('toast.cancelText'),
  //   //     type: 'warning',
  //   //   })
  //   //     .then(() => {
  //   //       this.$refs.BjGraph.onSave(next());
  //   //     })
  //   //     .catch(() => {
  //   //       next();
  //   //     });
  //   // }
  // },
  methods: {
    refreshData() {
      this.refresh = false;
      this.$nextTick(() => {
        this.refresh = true;
      });
    },
  },
};
</script>
